module.exports = __webpack_public_path__ + "media/images/general/sns/logo-facebook-91f7a36ae6633721326231ac9633e8f0.svg";